import React from 'react';
import { useSelector } from 'react-redux';
import Body from 'ui/Typography/Body';
import Title from 'ui/Typography/Title';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/focus/dist/style.css';
import Modal, { ModalHeader, ModalBody, Sheets } from '@ingka/modal';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useIntl } from 'react-intl';
import TopImage from './TopImage.png';
import BottomImage from './BottomImage.png';
import { useAppDispatch } from 'ducks/hooks';
import styled from 'styled-components';
import media from 'ui/media';
import {
  isAdjustableClothRailInformationSheetVisible,
  setAdjustableClothRailInformationSheet
} from 'rangeConfig/jonaxel/features/AdjustableClothRailFeature';

const Image = styled.img`
  width: 100%;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
`;

const TitleWrapper = styled.div`
  ${media.mobile`
    width: 100%;
    padding: 0.5rem 0;
  `}
`;

const AdjustableClothRailInformationSheet = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const sheetVisible = useSelector(isAdjustableClothRailInformationSheetVisible);

  const onDismiss = () => {
    dispatch(setAdjustableClothRailInformationSheet(false));
  };

  return (
    <Modal
      data-testid="adjustable-cloth-rail-information-sheet"
      visible={!!sheetVisible}
      handleCloseBtn={onDismiss}
    >
      <Sheets
        title={formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetTitle' })}
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={<></>}
      >
        <ModalBody style={{ paddingTop: '0px' }}>
          <TitleWrapper>
            <Title type={ThemeFontStyleTypeEnum.headingMedium}>
              {formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetTitle' })}
            </Title>
          </TitleWrapper>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium} mt="xl">
            {formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetBodyTop' })}
          </Body>
          <ImageWrapper>
            <Image
              src={TopImage}
              alt={formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetImageTopAlt' })}
            />
          </ImageWrapper>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium} mt="xxxl">
            {formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetBodyBottom' })}
          </Body>
          <ImageWrapper>
            <Image
              src={BottomImage}
              alt={formatMessage({ id: 'storageone.jonaxelAdjClRailInfoSheetImageBottomAlt' })}
            />
          </ImageWrapper>
        </ModalBody>
      </Sheets>
    </Modal>
  );
};

export default AdjustableClothRailInformationSheet;
